export enum PreferenceTypeCode {
  MY_INFO = "MY_INFO",
  HOUSEMATE = "HOUSEMATE",
  ROOM_SCALE = "ROOM_SCALE",
  HOME_APPLIANCE = "HOME_APPLIANCE",
  USER_STYLE = "USER_STYLE",
  ALL = "PREFERENCE_ALL",
}
